import React, { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { WaterHardnessCheck } from "@/components/WaterHardnessCheck";
import { Services } from "@/components/Services";
import { WhyUs } from "@/components/WhyUs";
import { About } from "@/components/About";
import { HowItWorks } from "@/components/HowItWorks";
import { Blog } from "@/components/Blog";
import { Reviews } from "@/components/Reviews";
import { FAQ } from "@/components/FAQ";
import { CtaBand } from "@/components/CtaBand";
import { Footer } from "@/components/Footer";
import { Chatbot } from "@/components/Chatbot";

export default function Home() {
  useEffect(() => {
    document.title = "Senior Stylist | On-Demand Hair Consultations";
  }, []);
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <HowItWorks />
        <WhyUs />
        <Services />
        <section className="relative overflow-hidden bg-stylist-ink py-14 md:py-20" data-testid="home-water-check">
          <div className="absolute inset-0 ss-grain opacity-[0.06] pointer-events-none" />
          <div
            className="absolute inset-0 opacity-80 pointer-events-none"
            style={{ background: "radial-gradient(ellipse at 50% -10%, rgba(197,155,39,0.26), transparent 62%)" }}
          />
          <div className="relative max-w-3xl mx-auto px-4 sm:px-8 lg:px-16">
            <WaterHardnessCheck />
          </div>
        </section>
        <Blog />
        <About />
        <Reviews />
        <FAQ />
        <CtaBand />
      </main>
      <Footer />

      <Chatbot />
    </>
  );
}
